import * as types from '../../index';

export const listFieldDetails = (data) => {
    return {
    type: types.LIST_FIELD_DETAILS,
    data
    }
};

export const saveFieldDetails = (data) => {
    return {
    type: types.SAVE_FIELD_DETAILS,  
    data
    }
}  

export const deleteFieldDetails = (data) => {
    return {
    type: types.DELETE_FIELD_DETAILS,  
    data
    }
}

export const saveVehicleInfo = (data) => {
    return {
    type: types.SAVE_VEHICLE_INFO,  
    data
    }
}

export const listVehicleInfo = (data) => {
    return {
    type: types.LIST_VEHICLE_INFO,  
    data
    }
}
export const deleteVehicleInfo = (data) => {
    return {
    type: types.DELETE_VEHICLE_INFO,  
    data
    }
}
export const updateVehicleInfo = (data) => {
    return {
    type: types.UPDATE_VEHICLE_INFO,  
    data
    }
}
export const getVehicleInfo = (data) => {
    return {
    type: types.GET_VEHICLE_INFO,  
    data
    }
}